import cn from 'classnames';
import PropTypes from 'prop-types';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/address/addressformats/multiLineAddress.scss';

const MultiLineAddress = ({ address = {}, editLink, isBaseForHighlight, isSelected }, { testId }) => {
  if (!Object.keys(address).length) {
    return null;
  }

  const phoneWrapperStyle = cn(
    css.phoneWrapper,
    { [css.isSelected]: isSelected }
  );

  const {
    fullName,
    addressLine1,
    addressLine2,
    city,
    stateOrRegion,
    postalCode,
    phoneNumber,
    countryName
  } = address;

  return (
    <Row data-test-id={testId('multiLineAddress')} extraClass={css.multiLineAddressWrapper}>
      <RowSpan span="12">
        <div className={css.forceWrap}><strong>{fullName}</strong></div>
      </RowSpan>
      <RowSpan span="12" data-test-id={testId('mlaLine1')}>
        <div className={css.forceWrap}>{addressLine1}</div>
      </RowSpan>
      <RowSpan span="12" data-test-id={testId('mlaLine2')}>
        { addressLine2 && <div className={css.forceWrap}>{addressLine2}</div> }
      </RowSpan>
      <RowSpan span="12" data-test-id={testId('mlaLine3')}>
        <div className={css.forceWrap}>{city}, {stateOrRegion} {postalCode}</div>
      </RowSpan>
      {
        !isBaseForHighlight
          ? <RowSpan span="12">
            {countryName}
          </RowSpan>
          : null
      }

      {
        !isBaseForHighlight
          ? <RowSpan span="12">
            <span className={phoneWrapperStyle}>{phoneNumber}</span>
            { editLink ? editLink : null }
          </RowSpan>
          : null
      }
    </Row>
  );
};

MultiLineAddress.contextTypes = {
  testId: PropTypes.func
};

export default MultiLineAddress;
